// extracted by mini-css-extract-plugin
export default {"main-container":"TwoFactorAuth_main-container__H21os","content":"TwoFactorAuth_content__Y-Lal"};